import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

const RecordingTimer = ({ seconds }) => {
    const formatTime = (totalSeconds) => {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const secs = totalSeconds % 60;

        if (hours > 0) {
            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
        }
        return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    return (
        <Box textAlign="center" my={2}>
            <Typography variant="h3" fontWeight="bold" color="primary">
                {formatTime(seconds)}
            </Typography>
        </Box>
    );
};

export default RecordingTimer;
